<template>
    <nav
        class="shareMenu"
        :class="{'-isOpen' : isOpen }"
        style="--item-count: 4"
    >
        <button
            class="shareMenu__trigger"
            :aria-label="isOpen ? 'Close' : 'Share'"
            @click="toggleMenu"
        >
            <svg v-if="isOpen" id="close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M14.84,12L23.41,3.43c.78-.78,.78-2.06,0-2.84s-2.06-.78-2.84,0L12,9.16,3.43,.59C2.64-.2,1.37-.2,.59,.59S-.2,2.64,.59,3.43L9.16,12,.59,20.57c-.78,.78-.78,2.06,0,2.84s2.06,.78,2.84,0h0L12,14.84l8.57,8.57c.78,.78,2.06,.78,2.84,0s.78-2.06,0-2.84L14.84,12Z" fill="var(--share-icon-bg, #fff)"/>
            </svg>
            <svg v-else id="open" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.68 24">
                <path d="M18.08,16.97c-.88,0-1.72,.33-2.36,.93L7.13,12.89c.07-.28,.1-.56,.11-.84,0-.28-.04-.57-.11-.84L15.63,6.25c1.46,1.35,3.74,1.26,5.1-.2,1.35-1.46,1.26-3.74-.2-5.1-1.46-1.35-3.74-1.26-5.1,.2-.62,.67-.96,1.55-.96,2.46,0,.28,.04,.57,.11,.84L6.09,9.41c-1.46-1.36-3.74-1.29-5.11,.17-1.36,1.46-1.29,3.74,.17,5.11,1.39,1.3,3.55,1.3,4.94,0l8.58,5.01c-.06,.26-.09,.52-.1,.78,0,1.94,1.58,3.52,3.52,3.52s3.52-1.58,3.52-3.52-1.58-3.52-3.52-3.52h0Z" fill="var(--share-icon-fill, #000)"/>
            </svg>
            <div class="sr-only">{{  isOpen ? 'Close Share Menu' : 'Open Share Menu' }}</div>
        </button>
        <ul class="shareMenu__list">
            <li class="shareMenu__item" style="--i: 1">
                <a :href="networks['facebook']" target="_new">
                    <button class="shareMenu__itemTrigger">
                        <svg id="share-icon-facebook" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33.02">
                            <circle class="shareMenu__itemBg" cx="16.5" cy="16.5" r="16.5" fill="var(--share-icon-fill, #000)"/>
                            <path class="shareMenu__itemIcon" d="M18.81,21.39h3.88l.74-4.81h-4.62v-3.12c0-1.32,.64-2.6,2.71-2.6h2.1V6.76c-1.23-.2-2.48-.31-3.73-.32-3.8,0-6.29,2.3-6.29,6.48v3.67h-4.23v4.81h4.23v11.36c.94,.17,1.9,.27,2.89,.27,.79,0,1.55-.07,2.31-.18v-11.45Z" fill="var(--share-icon-bg, #fff)"/>
                        </svg>
                        <div class="sr-only">Share via Facebook</div>
                    </button>
                </a>
            </li>
            <li class="shareMenu__item" style="--i: 2">
                <a :href="networks['twitter']" target="_new">
                    <button class="shareMenu__itemTrigger">
                        <svg id="share-icon-twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
                            <circle cx="16.5" cy="16.5" r="16.5" class="shareMenu__itemBg" fill="var(--share-icon-fill, #000)"/>
                            <path class="shareMenu__itemIcon" fill="var(--share-icon-bg, #fff)" d="m18.54,14.82l8-9.29h-1.89l-6.94,8.07-5.55-8.07h-6.4l8.39,12.2-8.39,9.75h1.89l7.33-8.52,5.86,8.52h6.4l-8.7-12.66h0Zm-2.1,3.07l-.85-1.22-6.76-9.67h2.91l5.46,7.8.85,1.22,7.09,10.14h-2.91l-5.79-8.28h0Z"/>
                        </svg>
                        <div class="sr-only">Share via Twitter</div>
                    </button>
                </a>
            </li>
            <li class="shareMenu__item" style="--i: 3">
                <a :href="networks['linkedin']" target="_new">
                    <button class="shareMenu__itemTrigger">
                        <svg id="share-icon-linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
                            <circle class="shareMenu__itemBg" cx="16.5" cy="16.5" r="16.5" fill="var(--share-icon-fill, #000)"/>
                            <path class="shareMenu__itemIcon" d="M11.65,25.3h-3.65V13.55h3.65v11.76Zm-1.83-13.36c-1.17,0-2.13-.94-2.14-2.11,0-1.17,.94-2.13,2.11-2.14,1.17,0,2.13,.94,2.14,2.11h0c0,1.17-.94,2.13-2.11,2.14Zm15.49,13.36h-3.64v-5.72c0-1.36-.03-3.11-1.9-3.11s-2.19,1.48-2.19,3.02v5.82h-3.65V13.55h3.5v1.6h.05c.71-1.22,2.04-1.95,3.45-1.9,3.7,0,4.37,2.43,4.37,5.59v6.46h0Z" fill="var(--share-icon-bg, #fff)"/>
                        </svg>
                        <div class="sr-only">Share via LinkedIn</div>
                    </button>
                </a>
            </li>
            <li class="shareMenu__item" style="--i: 4">
                <a :href="networks['email']" target="_new">
                    <button class="shareMenu__itemTrigger">
                        <svg id="share-icon-email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
                            <circle class="shareMenu__itemBg" cx="16.5" cy="16.5" r="16.5" fill="var(--share-icon-fill, #000)"/>
                            <path class="shareMenu__itemIcon" d="M24.97,8.03H8.03c-1.17,0-2.11,.95-2.11,2.12v12.71c0,1.17,.94,2.11,2.11,2.12H24.97c1.17,0,2.11-.95,2.12-2.12V10.15c0-1.17-.95-2.11-2.12-2.12Zm0,14.83H8.03V12.26l8.47,5.3,8.47-5.3v10.59Zm-8.47-7.41l-8.47-5.3H24.97l-8.47,5.3Z" fill="var(--share-icon-bg, #fff)"/>
                        </svg>
                        <div class="sr-only">Share via Email</div>
                    </button>
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
/**
 * Network LinkProperties:
 * @u = url
 * @t = title
 * @d = description
 * @q = quote
 * @h = hashtags
 * @m = media
 * @tu = twitterUser
 */
const networkLinks = {
    email: 'mailto:?subject=@t&body=@u%0D%0A@d',
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h',
    linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=@u&title=@t&summary=@d',
    twitter: 'https://twitter.com/intent/tweet?text=@t&url=@u&hashtags=@h@tu',
}

let $window = typeof window !== 'undefined' ? window : null

// Based on: https://github.com/nicolasbeauvais/vue-social-sharing/blob/master/src/share-network.js
export default {
    name: 'share-menu',

    props: {
        // Url of the content to share.
        src: {
            type: String,
            required: true,
        },
        // Title of the content to share.
        title: {
            type: String,
            required: true,
        },
        // Description of the content to share.
        description: {
            type: String,
            default: '',
        },
        // Hashtags used for Facebook and Twitter.
        hashtags: {
            type: String,
            default: '',
        },
        // Twitter User
        twitterUser: {
            type: String,
            default: '',
        },
        // Popup window properties.
        popup: {
            type: Object,
            default: () => ({
                width: 600,
                height: 436,
            })
        },
    },

    data: () => ({
        isOpen: false,
        popupTop: 0,
        popupLeft: 0,
        popupWindow: undefined,
        popupInterval: null
    }),

    computed: {
        networks() {
            const networks = {}

            for ( const key in networkLinks ) {
                let link = networkLinks[key]

                if ( key == 'twitter' ) {
                    if (!this.hashtags.length) link = link.replace('&hashtags=@h', '')
                    if (!this.twitterUser.length) link = link.replace('@tu', '')
                }

                networks[key] = link
                    .replace(/@tu/g, '&via=' + encodeURIComponent(this.twitterUser))
                    .replace(/@u/g, encodeURIComponent(this.src))
                    .replace(/@t/g, encodeURIComponent(this.title))
                    .replace(/@d/g, encodeURIComponent(this.description))
                    .replace(/@q/g, encodeURIComponent(this.quote))
                    .replace(/@h/g, this.encodedHashtags( key ))
                    .replace(/@m/g, encodeURIComponent(this.media))
            }

            return networks
        },

    },

    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen
        },

        /**
         * Center the popup on multi-screens
         * http://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen/32261263
         */
        resizePopup() {
            const width = $window.innerWidth || (document.documentElement.clientWidth || $window.screenX)
            const height = $window.innerHeight || (document.documentElement.clientHeight || $window.screenY)
            const systemZoom = width / $window.screen.availWidth

            this.popupLeft = (width - this.popup.width) / 2 / systemZoom + ($window.screenLeft !== undefined ? $window.screenLeft : $window.screenX)
            this.popupTop = (height - this.popup.height) / 2 / systemZoom + ($window.screenTop !== undefined ? $window.screenTop : $window.screenY)
        },

        encodedHashtags( network ) {
            if ( network === 'facebook' && this.hashtags.length ) {
                return '%23' + this.hashtags.replace(/\s+/g, '').split(',')[0]
            }

            return this.hashtags.replace(/\s+/g, '')
        },

        // onClick( network ) {
        //     this.share(network)
        // },

        /**
         * Shares URL in specified network.
         */
        // share( network ) {

            // this.resizePopup()

            // // If a popup window already exist, we close it and trigger a change event.
            // if (this.popupWindow && this.popupInterval) {
            //     clearInterval(this.popupInterval)

            //     // Force close (for Facebook)
            //     try {
            //         this.popupWindow.close()
            //     } catch (e) {
            //         console.log(e)
            //     }


            //     this.emit('change')
            // }

            // this.popupWindow = $window.open(
            //     this.networks[network],
            //     'sharer-' + this.key,
            //     ',height=' + this.popup.height +
            //     ',width=' + this.popup.width +
            //     ',left=' + this.popupLeft +
            //     ',top=' + this.popupTop +
            //     ',screenX=' + this.popupLeft +
            //     ',screenY=' + this.popupTop
            // )

            // // If popup are prevented (AdBlocker, Mobile App context..), popup.window stays undefined and we can't display it
            // if (!this.popupWindow) {
            //     this.touch( network )
            //     return
            // }

            // this.popupWindow.focus()

            // // Create an interval to detect popup closing event
            // try {
            //     this.popupInterval = setInterval(() => {
            //         if (!this.popupWindow || this?.popupWindow?.closed) {
            //             clearInterval(this.popupInterval)

            //             this.popupWindow = null

            //             this.emit('close')
            //         }
            //     }, 500)
            // } catch (e) {
            //     console.log(e)
            // }


        //     this.emit('open')
        // },

        /**
         * Touches network and emits click event.
         */
        // touch( network ) {
        //     window.open(this.networks[network], '_blank')

        //     this.emit('open')
        // },

        // emit(name) {
        //     this.$root.$emit('share_network_' + name, this.key, this.url)
        //     this.$emit(name, this.key, this.url)
        // }
    }

}
</script>
